export default (function (tag, element) {
  if (element.taggedItems[tag]) {
    return element.taggedItems[tag].html.html;
  }
  return "[".concat(tag, "]");
});